import { RedoOutlined, SearchOutlined } from "@ant-design/icons"
import { Button, Card, ConfigProvider, Form, Input, Select, Space } from "antd"
import type React from "react"
import { memo, useEffect } from "react"
import type { VocabularySearchParams } from "@/services/dictionary/vocabularyApi"

interface VocabularySearchFormProps {
  onSearch: (values: Omit<VocabularySearchParams, "page" | "per_page">) => void
  loading?: boolean
  initialValues?: Omit<VocabularySearchParams, "page" | "per_page">
}

const SystemVocabularySearchForm: React.FC<VocabularySearchFormProps> = memo(
  ({ onSearch, loading = false, initialValues }) => {
    const [form] = Form.useForm()

    useEffect(() => {
      if (initialValues) {
        form.setFieldsValue(initialValues)
      }
    }, [initialValues, form])

    const handleSearch = () => {
      form.validateFields().then((values) => {
        onSearch(values)
      })
    }

    const handleReset = () => {
      form.resetFields()
      onSearch({
        search: "",
        reference_type: undefined,
      })
    }

    const referenceTypeOptions = [
      { label: "Từ đơn (word)", value: "word" },
      { label: "Cụm động từ (phrasal_verb)", value: "phrasal_verb" },
      { label: "Collocation", value: "collocation" },
      { label: "Thành ngữ (idiom)", value: "idiom" },
      { label: "Cụm từ (phrase)", value: "phrase" },
    ]

    return (
      <ConfigProvider
        theme={{
          components: {
            Form: {
              itemMarginBottom: 0,
            },
          },
        }}
      >
        <Card>
          <Form
            form={form}
            initialValues={{
              search: "",
              reference_type: undefined,
            }}
            className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
          >
            <Form.Item name="search" label="Tìm kiếm" colon={false} className="mb-0">
              <Input allowClear autoComplete="off" placeholder="Nhập từ vựng..." onPressEnter={handleSearch} />
            </Form.Item>

            <Form.Item name="reference_type" label="Loại tham chiếu" colon={false} className="mb-0">
              <Select
                allowClear
                placeholder="Chọn loại từ điển"
                options={referenceTypeOptions}
                onChange={handleSearch}
              />
            </Form.Item>

            <Form.Item label=" " colon={false} className="mb-0">
              <Space>
                <Button type="default" icon={<RedoOutlined />} onClick={handleReset}>
                  Đặt lại
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  icon={<SearchOutlined />}
                  onClick={handleSearch}
                >
                  Tìm kiếm
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Card>
      </ConfigProvider>
    )
  }
)

SystemVocabularySearchForm.displayName = "SystemVocabularySearchForm"

export default SystemVocabularySearchForm
